/*
 * Touch "peek" on product cards that cannot swipe (home carousels, where a
 * horizontal swipe belongs to the carousel itself): hold a finger on the
 * photo and the second shot shows; let go and it returns. A short tap still
 * opens the product. The swipe cards in the catalog grid are left alone —
 * there a swipe already is the way to the second photo.
 */
(function () {
  if (!('ontouchstart' in window)) return;

  var HOLD = 200;
  var timer = null;
  var active = null;
  var peeked = false;
  var startX = 0;
  var startY = 0;

  function end() {
    clearTimeout(timer);
    timer = null;
    if (active) active.classList.remove('is-peek');
    active = null;
  }

  document.addEventListener('touchstart', function (event) {
    var wrap = event.target.closest && event.target.closest('.minimal-card-image-wrapper');
    if (!wrap || wrap.classList.contains('has-swipe') || !wrap.querySelector('.minimal-card-hover-img')) return;
    if (event.target.closest('.minimal-card-strip')) return;
    peeked = false;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    active = wrap;
    timer = setTimeout(function () {
      if (!active) return;
      active.classList.add('is-peek');
      peeked = true;
    }, HOLD);
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!active) return;
    var dx = Math.abs(event.touches[0].clientX - startX);
    var dy = Math.abs(event.touches[0].clientY - startY);
    // The carousel or the page is scrolling: that is not a peek.
    if (dx > 8 || dy > 8) end();
  }, { passive: true });

  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });

  // A hold that showed the second photo is not a tap on the product.
  document.addEventListener('click', function (event) {
    if (!peeked) return;
    if (event.target.closest && event.target.closest('.minimal-card-image-wrapper')) {
      event.preventDefault();
      event.stopPropagation();
    }
    peeked = false;
  }, true);

  // iOS shows the image callout on a long press; the peek replaces it.
  document.addEventListener('contextmenu', function (event) {
    if (event.target.closest && event.target.closest('.minimal-card-image-wrapper:not(.has-swipe)')) event.preventDefault();
  });
})();
